import type { ResourcesContent } from "../types";

export const resources: ResourcesContent = {
  title: "Læs, lær, udforsk.",
  lead: "Opslagshistorien, dokumentationen og de danske modeller under udvikling.",
  cards: [
    {
      tag: "Direktørens note · Opstart",
      title: "Hvorfor vi byggede UCloud AI",
      excerpt:
        "Dansk forskningsdata forlader landet hver dag via udenlandske chatvinduer og API'er. Med UCloud AI er det slut. Hver token beregnes i Danmark, via den nationale platform, som du allerede stoler på, og din forskning er aldrig træningsdata. Suverænitet er ikke et slogan, det er et login, du allerede har.",
      meta: "Prof. Claudio Pica · SDU eScience Center",
    },
    {
      tag: "Dokumentation",
      title: "Fra login til første token på fem minutter",
      excerpt:
        "Log ind med dit universitetslogin, vælg en model og kald det OpenAI-kompatible API direkte fra dit projekt. Gennemgangen, fra ende til anden.",
      meta: "Opdateret sep. 2026",
    },
    {
      tag: "Danish Foundation Models",
      title: "Bygger fundamentet for dansk AI",
      excerpt:
        "Sprogmodeller er blevet kritisk infrastruktur, og mindre sprog som dansk risikerer at blive overset. DFM er det nationale samarbejde om åben dansk AI, trænet på UCloud og på vej til kataloget.",
      meta: "foundationmodels.dk",
    },
  ],
};
